import React from 'react';
import { useTranslation } from 'react-i18next';
import { userTierKey } from '@/lib/tier';
import { UserAvatar } from '@/components/UserAvatar';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LayoutDashboard, LogOut, User, Shield, ChevronDown, Gift } from 'lucide-react';

// Desktop avatar dropdown (profile / dashboard / referrals / admin / logout).
export const UserMenu = ({ user, onNavigate, onLogout }) => {
  const { t } = useTranslation();
  const tierK = userTierKey(user);
  const planLabel = tierK === 'elite' ? t('common.elite') : tierK === 'pro' ? t('common.pro') : t('common.free');
  const planColor = tierK === 'elite' ? 'text-[#FFB020]' : tierK === 'pro' ? 'text-[#FF6B35]' : 'text-muted-foreground';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 pl-2 outline-none" data-testid="nav-user-menu">
          <UserAvatar src={user.avatar} name={user.name || user.email} size={36} />
          <div className="leading-tight text-left">
            <div className="text-sm font-medium max-w-[120px] truncate">{user.name || t('nav.rider')}</div>
            <div className={`text-[10px] font-semibold uppercase ${planColor}`}>{planLabel}</div>
          </div>
          <ChevronDown className="w-4 h-4 text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-[#12161B] border-white/15 text-white">
        <DropdownMenuLabel className="text-muted-foreground font-normal text-xs truncate">{user.email}</DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem onClick={() => onNavigate('/profile')} className="cursor-pointer focus:bg-white/10" data-testid="nav-profile-link"><User className="w-4 h-4 mr-2" /> {t('nav.myProfile')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onNavigate('/dashboard')} className="cursor-pointer focus:bg-white/10"><LayoutDashboard className="w-4 h-4 mr-2" /> {t('nav.dashboard')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onNavigate('/referrals')} className="cursor-pointer focus:bg-white/10 text-[#2EE59D]" data-testid="nav-referrals-link"><Gift className="w-4 h-4 mr-2" /> {t('nav.referrals')}</DropdownMenuItem>
        {user.is_admin && (
          <DropdownMenuItem onClick={() => onNavigate('/admin')} className="cursor-pointer focus:bg-white/10 text-[#FFB020]" data-testid="nav-admin-link"><Shield className="w-4 h-4 mr-2" /> {t('nav.adminPanel')}</DropdownMenuItem>
        )}
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem onClick={onLogout} className="cursor-pointer focus:bg-white/10 text-[#FF6B35]" data-testid="nav-logout-btn"><LogOut className="w-4 h-4 mr-2" /> {t('nav.logout')}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
